import axios from 'axios';

// API base URL - update this to match your FastAPI server
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

class CISOAdvisorAPI {
  constructor() {
    this.client = axios.create({
      baseURL: API_BASE_URL,
      headers: {
        'Content-Type': 'application/json',
      },
    });

    // Add request interceptor to include API key
    this.client.interceptors.request.use((config) => {
      const apiKey = localStorage.getItem('cisoAdvisorApiKey');
      if (apiKey) {
        config.headers['X-API-Key'] = apiKey;
      }
      return config;
    });
  }

  // Auth
  setApiKey(apiKey) {
    localStorage.setItem('cisoAdvisorApiKey', apiKey);
  }

  clearApiKey() {
    localStorage.removeItem('cisoAdvisorApiKey');
  }

  getApiKey() {
    return localStorage.getItem('cisoAdvisorApiKey');
  }

  // Health check
  async healthCheck() {
    const response = await this.client.get('/health');
    return response.data;
  }

  // Process query (chat)
  async processQuery(query, conversationId = null) {
    const response = await this.client.post('/api/query', {
      query,
      conversation_id: conversationId,
    });
    return response.data;
  }

  // Risk assessment
  async assessRisk(topologyId = null) {
    const response = await this.client.post('/api/assess-risk', {
      topology_id: topologyId,
    });
    return response.data;
  }

  // Get customer info
  async getCustomerInfo() {
    const response = await this.client.get('/api/customers/me');
    return response.data;
  }

  // List workflows
  async listWorkflows() {
    const response = await this.client.get('/api/workflows');
    return response.data;
  }

  // Get compliance status
  async getComplianceStatus() {
    const response = await this.client.post('/api/compliance/status', {});
    return response.data;
  }

  // Get threat intelligence
  async getThreatIntel(industry = 'finance') {
    const response = await this.client.post('/api/threat-intel', {
      industry,
    });
    return response.data;
  }

  // Generate report
  async generateReport(reportType = 'executive_summary', outputFormat = 'text') {
    const response = await this.client.post('/api/generate-report', {
      report_type: reportType,
      output_format: outputFormat,
      delivery_method: 'api',
    });
    return response.data;
  }

  // Create remediation plan
  async createRemediationPlan() {
    const response = await this.client.post('/api/remediation/plan', {});
    return response.data;
  }

  // Get pending approvals
  async getPendingApprovals(approvalLevel = null) {
    const response = await this.client.get('/api/approvals/pending', {
      params: { approval_level: approvalLevel },
    });
    return response.data;
  }
}

export default new CISOAdvisorAPI();
